import React from "react";
import { NavLink } from "react-router-dom";

const MainMenu = () => {
    return (
        <nav>
            <ul className="main-menu">
                <li>
                    <NavLink className="main-menu-link" activeClassName="active" exact to="/">
                        홈
                    </NavLink>
                </li>
                <li>
                    <NavLink className="main-menu-link" to={process.env.PUBLIC_URL + "/service"}>
                        진료과목
                    </NavLink>
                    <ul className="sub-menu">
                        <li>
                            <NavLink className="sub-menu-link" to={process.env.PUBLIC_URL + "/service"}>
                                전체 진료과목
                            </NavLink>
                        </li>
                        <li>
                            <NavLink className="sub-menu-link" to={process.env.PUBLIC_URL + "/service-details/1"}>
                                진료과 상세
                            </NavLink>
                        </li>
                    </ul>
                </li>

                <li>
                    <NavLink className="main-menu-link" to={process.env.PUBLIC_URL + "/about"}>
                        병원소개
                    </NavLink>
                </li>
                <li>
                    <NavLink className="main-menu-link" to={process.env.PUBLIC_URL + "/column"}>
                        닥터칼럼
                    </NavLink>
                </li>
                <li>
                    <NavLink className="main-menu-link" to={process.env.PUBLIC_URL + "/contact"}>
                        오시는길
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
};

export default MainMenu;
